<p>
  induction-modules works!
</p>
